/**
 * Seed a per-language profiles array with exactly one entry per currently
 * enabled language, IN THAT ORDER — matching `LanguageContext`'s positional
 * `languageId`, which every consumer of the seeded array addresses fields by
 * (`profiles.${languageId}.*`). Existing values are matched onto their
 * language and carried over; a language with no existing profile gets a
 * blank row from `blankFactory`.
 *
 * NEVER filter or reorder the result before it reaches `form.reset()`/
 * `form.setValue()` — doing so shifts every later language's profile onto
 * the wrong index, silently corrupting cross-language data. Mirrors
 * `ContentBlockFormBody`'s `allLanguages.map(...)` seeding and its
 * positional-profiles warnings. On save, send every seeded row as-is
 * (including empty-string labels) — these settings are FULL-REPLACE
 * mutations with no per-row id, so dropping a blank row deletes that
 * language's translation instead of leaving it untouched.
 */
export function seedProfiles<P extends { language: string }>(
  existingProfiles: P[] | null | undefined,
  allLanguages: string[],
  blankFactory: (language: string) => P
): P[] {
  const existing = existingProfiles ?? []
  return allLanguages.map(lang => {
    const found = existing.find(p => p.language === lang)
    return found ? { ...found } : blankFactory(lang)
  })
}
